import { post } from '../axios'

// 查询标签
export function v1_hot_tag_index_post(map, option) {
  return post(`${process.env.VUE_APP_V1}/v1/hot-tag/index`, map, option).then(
    response => response
  )
}

// 查询全部上架的标签
export function v1_hot_tag_upOnShelf_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/hot-tag/upOnShelf`,
    map,
    option
  ).then(response => response)
}

// 创建标签
export function v1_hot_tag_create_post(map, option) {
  return post(`${process.env.VUE_APP_V1}/v1/hot-tag/create`, map, option).then(
    response => response
  )
}

// 删除标签
export function v1_hot_tag_delete_post(map, option) {
  return post(`${process.env.VUE_APP_V1}/v1/hot-tag/delete`, map, option).then(
    response => response
  )
}

// 更新记录
export function v1_hot_tag_update_post(map, option) {
  return post(`${process.env.VUE_APP_V1}/v1/hot-tag/update`, map, option).then(
    response => response
  )
}

// 查询全部上架的标签 且 非自动上报的
export function v1_hot_tag_upOnShelfAll_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/hot-tag/upOnShelfAll`,
    map,
    option
  ).then(response => response)
}

// 设置非自动上报的标签上架
export function v1_hot_tag_setOnShelf_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/hot-tag/setOnShelf`,
    map,
    option
  ).then(response => response)
}

// 设置非自动上报的标签下架
export function v1_hot_tag_setOffShelf_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/hot-tag/setOffShelf`,
    map,
    option
  ).then(response => response)
}

// 自动上报菜单
export function v1_hot_tag_autoTrackMenu_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/hot-tag/autoTrackMenu`,
    map,
    option
  ).then(response => response)
}

// 查询当前用户下所有自动上报的数据，且按照数量从大到小排列
export function v1_hot_tag_getAutoMenuList_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/hot-tag/getAutoMenuList`,
    map,
    option
  ).then(response => response)
}
